import * as React from 'react'
import styled from 'styled-components'

import { useDramaticallyInefficientContain } from '../hooks/useDramaticallyInefficientContain'
import * as breakpoint from '../constants/breakpoints'
import * as icon from '../svg/icons'
import * as S from '../styles'

import { Overlay } from './Overlay'

export type MediaLoaderProps = Omit<React.HTMLAttributes<HTMLDivElement>, 'placeholder'> & {
  placeholder: React.ReactNode
  url: string
}

export function MediaLoaderComponent({
  placeholder,
  url,
  onClick,
  ...divProps
}: MediaLoaderProps): React.ReactElement<MediaLoaderProps> {
  const [loaded, setLoaded] = React.useState(false)

  return (
    <>
      <S.mediaLoader.Wrapper onClick={handleClick} {...divProps}>
        {placeholder}
        <icon.Play size={60} />
      </S.mediaLoader.Wrapper>
      {loaded && <ModalVideo url={url} onUnload={() => setLoaded(false)} />}
    </>
  )

  function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    setLoaded(true)
    onClick && onClick(event)
  }
}

export const MediaLoader = styled(MediaLoaderComponent)`
  @media screen and (${breakpoint.TABLET}) {
    ${S.picture.Image} {
      transition: transform 0.3s ease-in-out;
    }

    &:hover {
      ${S.picture.Image} {
        transition: transform 0.3s ease-in-out;
        transform: scale(1.1);
      }
    }
  }
`

export type ModalVideoProps = {
  className?: string
  onUnload: () => void
  url: string
}

function ModalVideoComponent({ onUnload, url, className }: ModalVideoProps) {
  const ratio = 1280 / 720
  const overlayRef = React.useRef<HTMLDivElement>(null)
  const coverDimension = useDramaticallyInefficientContain(overlayRef, ratio, [])
  return (
    <Overlay ref={overlayRef} onClick={onUnload} className={className}>
      <S.mediaLoader.SizeWrapper $width={coverDimension.width} $height={coverDimension.height}>
        <S.mediaLoader.Player url={url} playing width="100%" height="100%" controls />
      </S.mediaLoader.SizeWrapper>
    </Overlay>
  )
}

export const ModalVideo = styled(ModalVideoComponent)`
  display: flex;
  flex-wrap: wrap;
  padding: 5vh 5vw;

  @media screen and (${breakpoint.TABLET}) {
    padding: 15vh 15vw;
  }
`
